const DANH_SACH_GROUP = (state, danhSachGroup) => {
    state.danhSachGroup = danhSachGroup;
};

const DANH_SACH_GROUP_PAGING = (state, danhSachGroupPaging) => {
    state.danhSachGroupPaging = danhSachGroupPaging;
};
const SET_CHI_TIET_GROUP = (state, chiTietGroup) => {
    state.chiTietGroup = chiTietGroup;
};

const SET_DANH_SACH_VAI_TRO_THEO_GROUP = (
    state,
    danhSachVaiTroTheoGroup
) => {
    state.danhSachVaiTroTheoGroup = danhSachVaiTroTheoGroup;
};

const SET_DANH_SACH_QUYEN_THEO_GROUP = (
    state,
    danhSachQuyenTheoGroup
) => {
    state.danhSachQuyenTheoGroup = danhSachQuyenTheoGroup;
};

const SET_DANH_SACH_USER_NOT_INGROUP = (
    state,
    danhSachUserNotInGroup
) => {
    state.danhSachUserNotInGroup = danhSachUserNotInGroup;
};

export default {
    DANH_SACH_GROUP,
    DANH_SACH_GROUP_PAGING,
    SET_CHI_TIET_GROUP,
    SET_DANH_SACH_VAI_TRO_THEO_GROUP,
    SET_DANH_SACH_QUYEN_THEO_GROUP,
    SET_DANH_SACH_USER_NOT_INGROUP
};
